import React, { useState, useEffect, useRef, useCallback } from 'react';
import { createPortal } from 'react-dom';
import Icon from '../components/Icon';
import { io } from 'socket.io-client';
import SimplePeer from 'simple-peer';
import API from '../services/api';
import { fmtShort } from '../utils/date';
import { useLanguage } from '../context/LanguageContext';
import './Chat.css';

const REACTIONS = ['👍','❤️','😂','😮','😢','🙏'];

// Chat seçimində əməkdaş/şagird ayrımı
const STAFF_ROLES = ['admin', 'department_head', 'staff', 'teacher'];
const ROLE_LABEL = {
  admin: 'Administrator',
  department_head: 'Şöbə rəhbəri',
  staff: 'Əməkdaş',
  teacher: 'Müəllim',
  student: 'Şagird',
  ibtidai_sinif_muellimi: 'İbtidai sinif müəllimi',
  parent: 'Valideyn',
};
const roleText = (r) => ROLE_LABEL[r] || r || '';

const EMOJIS = [
  { e:'😀', k:'smile happy grin' },{ e:'😃', k:'smile happy' },{ e:'😄', k:'smile happy laugh' },{ e:'😁', k:'beam grin' },
  { e:'😆', k:'laugh haha lol' },{ e:'🤣', k:'rofl laugh' },{ e:'😂', k:'tears joy laugh cry' },{ e:'🙂', k:'slight smile' },
  { e:'🙃', k:'upside down silly' },{ e:'😉', k:'wink' },{ e:'😊', k:'blush smile' },{ e:'😇', k:'angel halo' },
  { e:'🥰', k:'love hearts' },{ e:'😍', k:'love heart eyes' },{ e:'🤩', k:'star eyes wow' },{ e:'😘', k:'kiss' },
  { e:'😗', k:'kiss' },{ e:'😚', k:'kiss closed' },{ e:'😙', k:'kiss smile' },{ e:'😋', k:'yum tongue' },
  { e:'😛', k:'tongue' },{ e:'😜', k:'tongue wink' },{ e:'🤪', k:'crazy zany' },{ e:'😝', k:'tongue closed eyes' },
  { e:'🤑', k:'money mouth' },{ e:'🤗', k:'hug' },{ e:'🤭', k:'oops giggle' },{ e:'🤫', k:'shh quiet' },
  { e:'🤔', k:'think hmm' },{ e:'🤐', k:'zip mouth' },{ e:'🤨', k:'raised eyebrow' },{ e:'😐', k:'neutral' },
  { e:'😑', k:'expressionless' },{ e:'😶', k:'no mouth' },{ e:'😏', k:'smirk' },{ e:'😒', k:'unamused' },
  { e:'🙄', k:'eye roll' },{ e:'😬', k:'grimace' },{ e:'🤥', k:'liar lying' },{ e:'😌', k:'relieved' },
  { e:'😔', k:'pensive sad' },{ e:'😪', k:'sleepy' },{ e:'😴', k:'sleep zzz' },{ e:'😷', k:'mask sick' },
  { e:'🤒', k:'sick' },{ e:'🤕', k:'hurt bandage' },{ e:'🤢', k:'sick nausea' },{ e:'🤮', k:'vomit' },
  { e:'🥵', k:'hot' },{ e:'🥶', k:'cold' },{ e:'🥴', k:'woozy' },{ e:'😵', k:'dizzy' },
  { e:'🤯', k:'mind blown' },{ e:'🤠', k:'cowboy' },{ e:'🥳', k:'party celebrate' },{ e:'😎', k:'cool sunglasses' },
  { e:'🤓', k:'nerd' },{ e:'🧐', k:'monocle' },{ e:'😕', k:'confused' },{ e:'😟', k:'worried' },
  { e:'🙁', k:'frown sad' },{ e:'☹️', k:'frown sad' },{ e:'😮', k:'surprised wow' },{ e:'😯', k:'hushed' },
  { e:'😲', k:'shocked' },{ e:'😳', k:'flushed' },{ e:'🥺', k:'pleading puppy' },{ e:'😦', k:'frown open' },
  { e:'😧', k:'anguished' },{ e:'😨', k:'fearful' },{ e:'😰', k:'anxious sweat' },{ e:'😥', k:'sad relief' },
  { e:'😢', k:'cry tear' },{ e:'😭', k:'sob cry' },{ e:'😱', k:'scream' },{ e:'😖', k:'confounded' },
  { e:'😣', k:'persevere' },{ e:'😞', k:'disappointed' },{ e:'😓', k:'sweat sad' },{ e:'😩', k:'weary' },
  { e:'😫', k:'tired' },{ e:'🥱', k:'yawn' },{ e:'😤', k:'huff' },{ e:'😡', k:'angry mad' },
  { e:'😠', k:'angry' },{ e:'🤬', k:'cursing' },{ e:'😈', k:'devil' },{ e:'👿', k:'imp angry' },
  { e:'💀', k:'skull dead' },{ e:'☠️', k:'skull crossbones' },{ e:'👽', k:'alien' },{ e:'👻', k:'ghost' },
  { e:'❤️', k:'heart love red' },{ e:'🧡', k:'heart orange' },{ e:'💛', k:'heart yellow' },{ e:'💚', k:'heart green' },
  { e:'💙', k:'heart blue' },{ e:'💜', k:'heart purple' },{ e:'🖤', k:'heart black' },{ e:'🤍', k:'heart white' },
  { e:'💔', k:'broken heart' },{ e:'❣️', k:'heart exclamation' },{ e:'💕', k:'two hearts' },{ e:'💖', k:'sparkle heart' },
  { e:'💗', k:'growing heart' },{ e:'💘', k:'heart arrow' },{ e:'💝', k:'heart gift' },{ e:'💞', k:'revolving hearts' },
  { e:'👍', k:'thumbs up like ok' },{ e:'👎', k:'thumbs down dislike' },{ e:'👌', k:'ok hand' },{ e:'✌️', k:'peace victory' },
  { e:'🤞', k:'fingers crossed' },{ e:'🤟', k:'love you' },{ e:'🤘', k:'rock horns' },{ e:'🤙', k:'call me' },
  { e:'👈', k:'point left' },{ e:'👉', k:'point right' },{ e:'👆', k:'point up' },{ e:'👇', k:'point down' },
  { e:'☝️', k:'index up' },{ e:'✋', k:'hand stop' },{ e:'🤚', k:'back hand' },{ e:'🖐️', k:'hand splayed' },
  { e:'🖖', k:'vulcan spock' },{ e:'👋', k:'wave hi hello' },{ e:'🤝', k:'handshake' },{ e:'🙏', k:'pray thanks please' },
  { e:'💪', k:'flex muscle strong' },{ e:'👏', k:'clap applause' },{ e:'🙌', k:'raise hands' },{ e:'🤲', k:'palms up' },
  { e:'🔥', k:'fire lit hot' },{ e:'⭐', k:'star' },{ e:'🌟', k:'glowing star' },{ e:'✨', k:'sparkles' },
  { e:'⚡', k:'lightning bolt' },{ e:'💥', k:'boom explosion' },{ e:'💯', k:'100 hundred perfect' },{ e:'✅', k:'check yes ok' },
  { e:'❌', k:'cross no x' },{ e:'⚠️', k:'warning' },{ e:'🚀', k:'rocket launch' },{ e:'🎉', k:'party celebrate' },
  { e:'🎊', k:'confetti' },{ e:'🎁', k:'gift present' },{ e:'🏆', k:'trophy winner' },{ e:'🥇', k:'gold medal' },
  { e:'🥈', k:'silver medal' },{ e:'🥉', k:'bronze medal' },{ e:'💡', k:'idea bulb' },{ e:'💰', k:'money bag' },
  { e:'💵', k:'dollar money' },{ e:'💸', k:'money fly' },{ e:'📎', k:'paperclip' },{ e:'📷', k:'camera photo' },
  { e:'📸', k:'camera flash' },{ e:'🎵', k:'music note' },{ e:'🎶', k:'music notes' },{ e:'🎮', k:'game controller' },
  { e:'⚽', k:'soccer football' },{ e:'🏀', k:'basketball' },{ e:'🍕', k:'pizza' },{ e:'🍔', k:'burger' },
  { e:'☕', k:'coffee' },{ e:'🎂', k:'cake birthday' },{ e:'🍻', k:'beer cheers' },{ e:'🥂', k:'cheers' },
];

let socketInstance = null;

function getSocket(token) {
  if (!socketInstance || !socketInstance.connected) {
    socketInstance = io(window.location.origin, {
      auth: { token },
      transports: ['websocket','polling']
    });
  }
  return socketInstance;
}

export default function Chat() {
  const { t } = useLanguage();
  const user = JSON.parse(localStorage.getItem('user') || '{}');
  const token = localStorage.getItem('token');

  const [socket, setSocket] = useState(null);
  const [conversations, setConversations] = useState([]);
  const [activeConv, setActiveConv] = useState(null);
  const [messages, setMessages] = useState([]);
  const [text, setText] = useState('');
  const [onlineUsers, setOnlineUsers] = useState(new Set());
  const [typing, setTyping] = useState({});
  const [showEmoji, setShowEmoji] = useState(false);
  const [showNewChat, setShowNewChat] = useState(false);
  const [showNewGroup, setShowNewGroup] = useState(false);
  const [allUsers, setAllUsers] = useState([]);
  const [groupName, setGroupName] = useState('');
  const [selectedUsers, setSelectedUsers] = useState([]);
  const [searchUser, setSearchUser] = useState('');
  const [userTab, setUserTab] = useState('staff');
  const [pendingImage, setPendingImage] = useState(null);
  const [uploading, setUploading] = useState(false);
  const [loadingMsgs, setLoadingMsgs] = useState(false);
  const [hasMore, setHasMore] = useState(false);
  // Group members panel
  const [showMembers, setShowMembers] = useState(false);
  const [groupMembers, setGroupMembers] = useState([]);
  const [showAddMember, setShowAddMember] = useState(false);
  const [memberSearch, setMemberSearch] = useState('');
  const [memberToAdd, setMemberToAdd] = useState([]);
  const [lightbox, setLightbox] = useState(null);
  const [msgMenu, setMsgMenu] = useState(null);

  // Mesaj reaksiyaları
  const [reactFor, setReactFor] = useState(null);   // hansı mesaj üçün seçici açıqdır
  const [reactPos, setReactPos] = useState(null);   // seçicinin ekrandakı yeri

  // Seçici document.body-yə portal ilə qoyulur: mesaj siyahısının overflow-u
  // onu kəsirdi. Düymənin real koordinatından yer hesablanır.
  const openReactPicker = (msgId, btnEl) => {
    if (reactFor === msgId) { setReactFor(null); return; }
    const r = btnEl.getBoundingClientRect();
    const W = 232, H = 46;
    const above = r.top > H + 12;
    setReactPos({
      left: Math.max(8, Math.min(r.left + r.width / 2 - W / 2, window.innerWidth - W - 8)),
      top: above ? r.top - H - 6 : r.bottom + 6,
      width: W,
    });
    setReactFor(msgId);
  };

  // Scroll və ya ölçü dəyişəndə seçici bağlanır (yeri köhnəlməsin)
  useEffect(() => {
    if (!reactFor) return;
    const close = () => setReactFor(null);
    window.addEventListener('scroll', close, true);
    window.addEventListener('resize', close);
    return () => {
      window.removeEventListener('scroll', close, true);
      window.removeEventListener('resize', close);
    };
  }, [reactFor]);

  const toggleReaction = async (m, emoji) => {
    setReactFor(null);
    try {
      const r = await API.post(`/conversations/${m.conversation_id}/messages/${m.id}/react`, { emoji });
      setMessages(prev => prev.map(x => x.id === m.id ? { ...x, reactions: r.data.reactions } : x));
    } catch (e) {
      alert(e.response?.data?.message || 'Reaksiya bildirilmədi');
    }
  };
  const longPressRef = useRef(null);

  const startLongPress = (msgId) => {
    if (longPressRef.current) clearTimeout(longPressRef.current);
    longPressRef.current = setTimeout(() => {
      if (navigator.vibrate) navigator.vibrate(40);
      setMsgMenu(msgId);
    }, 450);
  };
  const cancelLongPress = () => {
    if (longPressRef.current) { clearTimeout(longPressRef.current); longPressRef.current = null; }
  };
  const [pickerTab, setPickerTab] = useState('emoji');
  const [emojiSearch, setEmojiSearch] = useState('');
  const [gifSearch, setGifSearch] = useState('');
  const [gifResults, setGifResults] = useState([]);
  const [gifLoading, setGifLoading] = useState(false);

  const sendGif = (url) => {
    if (!activeConv || !socket) return;
    socket.emit('message:send', {
      conversation_id: activeConv.id,
      content: 'GIF',
      type: 'image',
      file_url: url,
      file_name: 'animation.gif',
      file_size: 0,
    });
    setShowEmoji(false);
  };

  useEffect(() => {
    if (!showEmoji || pickerTab !== 'gif') return;
    let cancelled = false;
    setGifLoading(true);
    const debounce = setTimeout(() => {
      API.get('/gifs/search', { params: { q: gifSearch.trim(), limit: 24 } })
        .then(r => {
          if (cancelled) return;
          setGifResults(r.data?.items || []);
        })
        .catch(() => { if (!cancelled) setGifResults([]); })
        .finally(() => { if (!cancelled) setGifLoading(false); });
    }, gifSearch.trim() ? 350 : 0);
    return () => { cancelled = true; clearTimeout(debounce); };
  }, [showEmoji, pickerTab, gifSearch]);

  const loadGroupMembers = async (convId) => {
    try {
      const r = await API.get('/conversations/' + convId + '/members');
      setGroupMembers(r.data || []);
    } catch (e) {}
  };

  const removeMember = async (memberId) => {
    if (!activeConv || !window.confirm(t('chatGroup.confirmRemove'))) return;
    try {
      await API.delete('/conversations/' + activeConv.id + '/members/' + memberId);
      loadGroupMembers(activeConv.id);
    } catch (e) { alert(e.response?.data?.message || t('chatGroup.removeFailed')); }
  };

  const changeRole = async (memberId, newRole) => {
    if (!activeConv) return;
    const confirmKey = newRole === 'admin' ? 'chatGroup.confirmPromote' : 'chatGroup.confirmDemote';
    if (!window.confirm(t(confirmKey))) return;
    try {
      await API.put('/conversations/' + activeConv.id + '/members/' + memberId + '/role', { role: newRole });
      loadGroupMembers(activeConv.id);
    } catch (e) { alert(e.response?.data?.message || t('chatGroup.roleChangeFailed')); }
  };

  const submitAddMembers = async () => {
    if (!activeConv || !memberToAdd.length) return;
    try {
      await API.post('/conversations/' + activeConv.id + '/members', { user_ids: memberToAdd });
      setMemberToAdd([]); setMemberSearch(''); setShowAddMember(false);
      loadGroupMembers(activeConv.id);
    } catch (e) { alert(e.response?.data?.message || t('chatGroup.addFailed')); }
  };

  const isGroupAdmin = !!groupMembers.find(m => m.id === user.id && m.role === 'admin');

  // Call state
  const [callState, setCallState] = useState(null); // null | 'incoming' | 'calling' | 'active'
  const [callData, setCallData] = useState(null);
  const [callType, setCallType] = useState('audio');
  const peersRef = useRef({});
  const localStreamRef = useRef(null);
  const localAudioRef = useRef(null);
  const remoteAudiosRef = useRef({});
  const callIdRef = useRef(null);
  const participantsRef = useRef([]);

  const messagesEndRef = useRef(null);
  const fileInputRef = useRef(null);
  const typingTimer = useRef(null);
  const activeConvRef = useRef(null);

  useEffect(() => { activeConvRef.current = activeConv; }, [activeConv]);

  // Initialize socket
  useEffect(() => {
    const s = getSocket(token);
    setSocket(s);

    s.on('online:list', (ids) => setOnlineUsers(new Set(ids)));
    s.on('user:online', ({ userId, online }) => {
      setOnlineUsers(prev => {
        const next = new Set(prev);
        if (online) next.add(userId); else next.delete(userId);
        return next;
      });
      // When a user goes offline, capture last_seen=now for active conv
      if (!online) {
        setActiveConv(prev => prev && prev.other_user_id === userId
          ? { ...prev, other_user_last_seen: new Date().toISOString() }
          : prev);
      }
    });
    s.on('message:new', (msg) => {
      if (activeConvRef.current && msg.conversation_id === activeConvRef.current.id) {
        setMessages(prev => [...prev, msg]);
        s.emit('conversation:join', msg.conversation_id);
        API.post('/conversations/' + msg.conversation_id + '/read').catch(() => {});
      }
      // Update last message in conv list
      setConversations(prev => prev.map(c =>
        c.id === msg.conversation_id
          ? { ...c, last_message: msg.content || '[fayl]', last_message_at: msg.created_at, unread_count: activeConvRef.current?.id === c.id ? 0 : (c.unread_count || 0) + (msg.sender_id !== user.id ? 1 : 0) }
          : c
      ).sort((a, b) => new Date(b.last_message_at || 0) - new Date(a.last_message_at || 0)));

      // Play notification sound if not active conv
      if (!activeConvRef.current || msg.conversation_id !== activeConvRef.current.id) {
        if (msg.sender_id !== user.id) playNotifSound();
      }
    });
    s.on('message:hidden', ({ message_id }) => {
      setMessages(prev => prev.filter(m => m.id !== message_id));
    });
    s.on('message:deleted', ({ message_id }) => {
      setMessages(prev => prev.map(m => m.id === message_id ? { ...m, is_deleted: 1, content: 'Mesaj silindi' } : m));
    });
    // Başqası reaksiya verəndə canlı yenilənsin
    s.on('message:reaction', ({ message_id, reactions }) => {
      setMessages(prev => prev.map(m => m.id === message_id
        ? { ...m, reactions: (reactions || []).map(r => ({ ...r, mine: (r.users || []).includes(user.id) })) }
        : m));
    });
    s.on('typing:start', ({ userId: uid, conversation_id, name }) => {
      if (activeConvRef.current?.id === conversation_id && uid !== user.id) {
        setTyping(prev => ({ ...prev, [uid]: name }));
      }
    });
    s.on('typing:stop', ({ userId: uid }) => {
      setTyping(prev => { const n = {...prev}; delete n[uid]; return n; });
    });

    // Call events
    s.on('call:incoming', (data) => {
      setCallData(data);
      setCallType(data.call_type);
      setCallState('incoming');
      playRingtone(true);
    });
    s.on('call:started', (data) => {
      callIdRef.current = data.call_id;
      setCallState('calling');
    });
    s.on('call:accepted', async (data) => {
      setCallState('active');
      playRingtone(false);
      // Initiate peer connection to the accepting user
      await startPeerConnection(data.user_id, true, s);
    });
    s.on('call:rejected', () => {
      setCallState(null); setCallData(null);
      playRingtone(false);
      endLocalStream();
      alert('Zəng rədd edildi');
    });
    s.on('call:ended', () => {
      endCall(false);
    });
    s.on('call:signal', async ({ from_user_id, signal, call_id }) => {
      if (call_id !== callIdRef.current) return;
      if (peersRef.current[from_user_id]) {
        peersRef.current[from_user_id].signal(signal);
      } else {
        // Non-initiator: create peer
        await startPeerConnection(from_user_id, false, s, signal);
      }
    });

    loadConversations();
    API.get('/users').then(r => setAllUsers(r.data)).catch(() => {});

    return () => {
      s.off('online:list'); s.off('user:online'); s.off('message:new');
      s.off('message:deleted'); s.off('message:hidden'); s.off('typing:start'); s.off('typing:stop');
      s.off('call:incoming'); s.off('call:started'); s.off('call:accepted');
      s.off('call:rejected'); s.off('call:ended'); s.off('call:signal');
    };
  }, []);

  const loadConversations = async () => {
    try {
      const res = await API.get('/conversations');
      setConversations(res.data);
    } catch (e) {}
  };

  const openConversation = async (conv) => {
    setActiveConv(conv);
    setMessages([]);
    setHasMore(false);
    setLoadingMsgs(true);
    try {
      const res = await API.get('/conversations/' + conv.id + '/messages', { params: { limit: 50 } });
      setMessages(res.data);
      setHasMore(res.data.length === 50);
      await API.post('/conversations/' + conv.id + '/read');
      setConversations(prev => prev.map(c => c.id === conv.id ? { ...c, unread_count: 0 } : c));
      socket && socket.emit('conversation:join', conv.id);
    } catch (e) {} finally {
      setLoadingMsgs(false);
    }
    setTimeout(() => messagesEndRef.current?.scrollIntoView(), 100);
  };

  useEffect(() => {
    messagesEndRef.current?.scrollIntoView({ behavior: 'smooth' });
  }, [messages]);

  const loadMore = async () => {
    if (!activeConv || !messages[0]) return;
    const res = await API.get('/conversations/' + activeConv.id + '/messages', { params: { limit: 50, before: messages[0].id } });
    setMessages(prev => [...res.data, ...prev]);
    setHasMore(res.data.length === 50);
  };

  const sendMessage = (e) => {
    e.preventDefault();
    if (!text.trim() || !activeConv || !socket) return;
    socket.emit('message:send', { conversation_id: activeConv.id, content: text.trim(), type: 'text' });
    setText('');
    setShowEmoji(false);
    clearTimeout(typingTimer.current);
    socket.emit('typing:stop', { conversation_id: activeConv.id });
  };

  const handleTextChange = (e) => {
    setText(e.target.value);
    if (!socket || !activeConv) return;
    socket.emit('typing:start', { conversation_id: activeConv.id });
    clearTimeout(typingTimer.current);
    typingTimer.current = setTimeout(() => socket.emit('typing:stop', { conversation_id: activeConv.id }), 2000);
  };

  const insertEmoji = (emoji) => {
    setText(prev => prev + emoji);
    setShowEmoji(false);
  };

  // Həm fayl seçimi, həm Ctrl+V yapışdırması bu funksiyadan keçir
  const uploadAndSend = async (file) => {
    if (!file || !activeConv) return;
    const form = new FormData();
    form.append('file', file, file.name);
    setUploading(true);
    try {
      const res = await API.post('/chat/upload', form, { headers: { 'Content-Type': 'multipart/form-data' } });
      socket.emit('message:send', {
        conversation_id: activeConv.id,
        content: res.data.name,
        type: res.data.type,
        file_url: res.data.url,
        file_name: res.data.name,
        file_size: res.data.size
      });
    } catch (err) {
      alert(err?.response?.data?.message || 'Fayl yüklənmədi');
    } finally {
      setUploading(false);
    }
  };

  const handleFileUpload = async (e) => {
    await uploadAndSend(e.target.files[0]);
    e.target.value = '';
  };

  // Ekran görüntüsünü birbaşa söhbətə yapışdırmaq (Ctrl+V)
  const handlePaste = (e) => {
    if (!activeConv) return;
    const items = Array.from(e.clipboardData?.items || []);
    const imgItem = items.find(it => it.kind === 'file' && it.type.startsWith('image/'));
    if (!imgItem) return;              // adi mətndirsə toxunmuruq
    const blob = imgItem.getAsFile();
    if (!blob) return;
    e.preventDefault();
    const ext = (blob.type.split('/')[1] || 'png').replace('jpeg', 'jpg');
    const named = new File([blob], 'ekran-goruntusu-' + Date.now() + '.' + ext, { type: blob.type });
    setPendingImage(prev => {
      if (prev) URL.revokeObjectURL(prev.url);
      return { file: named, url: URL.createObjectURL(named) };
    });
  };

  const clearPendingImage = () => {
    setPendingImage(prev => { if (prev) URL.revokeObjectURL(prev.url); return null; });
  };

  const sendPendingImage = async () => {
    if (!pendingImage) return;
    const f = pendingImage.file;
    clearPendingImage();
    await uploadAndSend(f);
  };

  const deleteForEveryone = (msg) => {
    if (msg.sender_id !== user.id) return;
    if (!window.confirm('Bu mesajı hamı üçün silmək istəyirsiniz?')) return;
    socket.emit('message:delete', { message_id: msg.id, conversation_id: activeConv.id });
    setMsgMenu(null);
  };

  const deleteForMe = (msg) => {
    if (!window.confirm('Bu mesajı yalnız sizin üçün silmək istəyirsiniz?')) return;
    socket.emit('message:hide', { message_id: msg.id, conversation_id: activeConv.id });
    setMessages(prev => prev.filter(m => m.id !== msg.id));
    setMsgMenu(null);
  };

  // New direct chat
  const startDirectChat = async (uid) => {
    try {
      const res = await API.post('/conversations/direct', { user_id: uid });
      await loadConversations();
      const convs = await API.get('/conversations');
      setConversations(convs.data);
      const found = convs.data.find(c => c.id === res.data.id);
      if (found) openConversation(found);
      setShowNewChat(false);
    } catch (e) { alert('Xəta'); }
  };

  // New group
  const createGroup = async () => {
    if (!groupName.trim() || selectedUsers.length < 1) return;
    try {
      await API.post('/conversations/group', { name: groupName, member_ids: selectedUsers });
      await loadConversations();
      setShowNewGroup(false); setGroupName(''); setSelectedUsers([]);
    } catch (e) { alert('Xəta'); }
  };

  // --- CALLS ---
  const playNotifSound = () => {
    try {
      const ctx = new (window.AudioContext || window.webkitAudioContext)();
      const osc = ctx.createOscillator();
      const gain = ctx.createGain();
      osc.connect(gain); gain.connect(ctx.destination);
      osc.frequency.value = 880;
      gain.gain.setValueAtTime(0.3, ctx.currentTime);
      gain.gain.exponentialRampToValueAtTime(0.001, ctx.currentTime + 0.3);
      osc.start(); osc.stop(ctx.currentTime + 0.3);
    } catch (e) {}
  };

  const ringtoneRef = useRef(null);
  const playRingtone = (play) => {
    if (play) {
      if (!ringtoneRef.current) {
        const ctx = new (window.AudioContext || window.webkitAudioContext)();
        ringtoneRef.current = ctx;
      }
      // Simple ringtone loop using oscillator - just play a sound indicator
      // In production use an audio file
    } else {
      if (ringtoneRef.current) {
        ringtoneRef.current.close().catch(() => {});
        ringtoneRef.current = null;
      }
    }
  };

  const startCall = async (type, participantIds) => {
    setCallType(type);
    participantsRef.current = participantIds;
    try {
      const stream = await navigator.mediaDevices.getUserMedia({ audio: true, video: false });
      localStreamRef.current = stream;
      if (localAudioRef.current) {
        localAudioRef.current.srcObject = stream;
        localAudioRef.current.muted = true;
      }
      socket.emit('call:invite', {
        conversation_id: activeConv.id,
        call_type: type,
        to_user_ids: participantIds
      });
      setCallState('calling');
      callIdRef.current = null;
    } catch (e) {
      alert('Mikrofona giriş icazəsi verilmədi');
    }
  };

  const acceptCall = async () => {
    playRingtone(false);
    try {
      const stream = await navigator.mediaDevices.getUserMedia({ audio: true, video: false });
      localStreamRef.current = stream;
      callIdRef.current = callData.call_id;
      participantsRef.current = [callData.from_user_id];
      socket.emit('call:accept', { call_id: callData.call_id, from_user_id: callData.from_user_id });
      setCallState('active');
      // Acceptor must also create a peer connection (non-initiator)
      await startPeerConnection(callData.from_user_id, false, socket);
    } catch (e) {
      alert('Mikrofona giriş icazəsi verilmədi');
      rejectCall();
    }
  };

  const rejectCall = () => {
    playRingtone(false);
    socket.emit('call:reject', { call_id: callData.call_id, from_user_id: callData.from_user_id });
    setCallState(null); setCallData(null);
  };

  const endCall = (emit = true) => {
    if (emit && socket) {
      socket.emit('call:end', { call_id: callIdRef.current, participant_ids: participantsRef.current });
    }
    endLocalStream();
    Object.values(peersRef.current).forEach(p => { try { p.destroy(); } catch(e) {} });
    peersRef.current = {};
    // Clean up all remote audio DOM elements
    Object.values(remoteAudiosRef.current).forEach(audio => {
      if (audio) { audio.srcObject = null; if (audio.parentNode) audio.parentNode.removeChild(audio); }
    });
    remoteAudiosRef.current = {};
    setCallState(null); setCallData(null);
    playRingtone(false);
  };

  const endLocalStream = () => {
    if (localStreamRef.current) {
      localStreamRef.current.getTracks().forEach(t => t.stop());
      localStreamRef.current = null;
    }
  };

  const startPeerConnection = async (targetUserId, initiator, s, existingSignal) => {
    const stream = localStreamRef.current;
    if (!stream) return;

    const peer = new SimplePeer({ initiator, stream, trickle: true });

    peer.on('signal', (signal) => {
      s.emit('call:signal', { to_user_id: targetUserId, signal, call_id: callIdRef.current });
    });
    peer.on('stream', (remoteStream) => {
      // Use a DOM audio element to ensure autoplay works
      let audio = remoteAudiosRef.current[targetUserId];
      if (!audio) {
        audio = document.createElement('audio');
        audio.autoplay = true;
        audio.playsInline = true;
        audio.setAttribute('autoplay', '');
        document.body.appendChild(audio);
        remoteAudiosRef.current[targetUserId] = audio;
      }
      audio.srcObject = remoteStream;
      audio.play().catch((err) => {
        console.warn('Audio play failed, retrying...', err);
        // Retry after user gesture
        const retry = () => { audio.play().catch(() => {}); document.removeEventListener('click', retry); };
        document.addEventListener('click', retry);
      });
    });
    peer.on('error', (err) => { console.warn('Peer error:', err); });
    peer.on('close', () => {
      // Clean up remote audio element
      const audio = remoteAudiosRef.current[targetUserId];
      if (audio) { audio.srcObject = null; if (audio.parentNode) audio.parentNode.removeChild(audio); }
      delete remoteAudiosRef.current[targetUserId];
      delete peersRef.current[targetUserId];
    });

    if (existingSignal) peer.signal(existingSignal);
    peersRef.current[targetUserId] = peer;
  };

  const formatTime = (d) => {
    const dt = new Date(d);
    return dt.toLocaleTimeString('az-AZ', { hour: '2-digit', minute: '2-digit' });
  };

  const formatLastSeen = (d) => {
    if (!d) return '';
    const dt = new Date(d);
    const now = new Date();
    const diffSec = Math.floor((now - dt) / 1000);
    if (diffSec < 60) return 'son görünmə: indi';
    if (diffSec < 3600) return 'son görünmə: ' + Math.floor(diffSec / 60) + ' dəq əvvəl';
    const today = new Date(); today.setHours(0,0,0,0);
    const dtDay = new Date(dt); dtDay.setHours(0,0,0,0);
    const dayDiff = Math.floor((today - dtDay) / 86400000);
    const hhmm = dt.toLocaleTimeString('az-AZ', { hour: '2-digit', minute: '2-digit' });
    if (dayDiff === 0) return 'son görünmə: bu gün ' + hhmm;
    if (dayDiff === 1) return 'son görünmə: dünən ' + hhmm;
    return 'son görünmə: ' + fmtShort(dt) + ' ' + hhmm;
  };

  const formatDate = (d) => {
    const dt = new Date(d);
    const today = new Date();
    if (dt.toDateString() === today.toDateString()) return 'Bu gün';
    const yesterday = new Date(today); yesterday.setDate(today.getDate()-1);
    if (dt.toDateString() === yesterday.toDateString()) return 'Dünən';
    return dt.toLocaleDateString('az-AZ');
  };

  const convName = (c) => c.name || c.other_user_name || '?';
  const isOnline = (c) => c.other_user_id && onlineUsers.has(c.other_user_id);

  const matchesUserSearch = (u) => (u.name || '').toLowerCase().includes(searchUser.toLowerCase());
  const selectable = allUsers.filter(u => u.id !== user.id);
  // Şagird olmayan hamı "Əməkdaşlar"dadır — rol siyahısına əsaslansaq,
  // sonradan əlavə olunan rol (məs. ibtidai sinif müəllimi) heç bir
  // sekməyə düşməz və həmin adam çatda görünməz olar.
  const staffUsers = selectable.filter(u => u.role !== 'student');
  const studentUsers = selectable.filter(u => u.role === 'student');
  const filteredUsers = (userTab === 'student' ? studentUsers : staffUsers).filter(matchesUserSearch);

  // Group messages by date
  const groupedMessages = [];
  let lastDate = null;
  messages.forEach((m) => {
    const d = formatDate(m.created_at);
    if (d !== lastDate) { groupedMessages.push({ type: 'date', label: d }); lastDate = d; }
    groupedMessages.push({ type: 'msg', data: m });
  });

  const callMembers = activeConv?.members?.filter(m => m.id !== user.id).map(m => m.id) || [];

  return (
    <div className={'chat-root' + (activeConv ? ' chat-conv-active' : '')}>
      {/* Sidebar */}
      <div className="chat-sidebar">
        <div className="chat-sidebar-header">
          <h3>{t('chat.title')}</h3>
          <div className="chat-header-btns">
            <button onClick={() => setShowNewChat(true)} title={t('chat.btnNewChat')}>
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" width="18" height="18"><path d="M21 15a2 2 0 01-2 2H7l-4 4V5a2 2 0 012-2h14a2 2 0 012 2z"/></svg>
            </button>
            <button onClick={() => setShowNewGroup(true)} title={t('chat.btnCreateGroup')}>
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" width="18" height="18"><path d="M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 00-3-3.87M16 3.13a4 4 0 010 7.75"/></svg>
            </button>
          </div>
        </div>
        <div className="chat-conv-list">
          {conversations.length === 0 && <p className="chat-empty">{t('chat.noChats')}</p>}
          {conversations.map(c => (
            <div
              key={c.id}
              className={'chat-conv-item' + (activeConv?.id === c.id ? ' active' : '')}
              onClick={() => openConversation(c)}
            >
              <div className="conv-avatar-wrap">
                <div className="conv-avatar">{(c.type === 'group' ? (c.name||'G') : (c.name||'?')).charAt(0).toUpperCase()}</div>
                {c.type === 'direct' && isOnline(c) && <span className="online-dot"></span>}
              </div>
              <div className="conv-info">
                <div className="conv-top">
                  <span className="conv-name">{c.type === 'group' ? c.name : c.name}</span>
                  <span className="conv-time">{c.last_message_at ? formatTime(c.last_message_at) : ''}</span>
                </div>
                <div className="conv-last">
                  <span className="conv-last-msg">
                    {c.last_message_type === 'image' ? <><Icon name="camera" size={12} /> Şəkil</> :
                     c.last_message_type === 'file' ? <><Icon name="paperclip" size={12} /> Fayl</> :
                     c.last_message || 'Söhbət başla...'}
                  </span>
                  {c.unread_count > 0 && <span className="unread-badge">{c.unread_count}</span>}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Main chat area */}
      <div className="chat-main">
        {!activeConv ? (
          <div className="chat-welcome">
            <svg viewBox="0 0 24 24" fill="none" stroke="#007c82" strokeWidth="1.5" width="64" height="64">
              <path d="M21 15a2 2 0 01-2 2H7l-4 4V5a2 2 0 012-2h14a2 2 0 012 2z"/>
            </svg>
            <p>Söhbət seçin və ya yeni söhbət başladın</p>
          </div>
        ) : (
          <>
            {/* Chat header */}
            <div className="chat-conv-header">
              <button className="chat-back-btn" onClick={() => setActiveConv(null)} title="Geri">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round" width="22" height="22">
                  <path d="M19 12H5M12 19l-7-7 7-7"/>
                </svg>
              </button>
              <div className="conv-avatar-wrap">
                <div className="conv-avatar lg">{convName(activeConv).charAt(0).toUpperCase()}</div>
                {activeConv.type === 'direct' && isOnline(activeConv) && <span className="online-dot"></span>}
              </div>
              <div style={{flex:1, cursor: activeConv.type === 'group' ? 'pointer' : 'default'}}
                onClick={() => { if (activeConv.type === 'group') { setShowMembers(true); loadGroupMembers(activeConv.id); } }}>
                <div className="conv-header-name">{convName(activeConv)}</div>
                <div className="conv-header-sub">
                  {activeConv.type === 'group'
                    ? (activeConv.members?.length || 0) + ' ' + t('chat.member')
                    : isOnline(activeConv)
                      ? t('chat.statusOnline')
                      : (activeConv.other_user_last_seen
                          ? formatLastSeen(activeConv.other_user_last_seen)
                          : t('chat.statusOffline'))}
                </div>
              </div>
              <div className="chat-call-btns">
                {activeConv.type === 'group' && (
                  <button onClick={() => { setShowMembers(true); loadGroupMembers(activeConv.id); }} title={t('chatGroup.viewMembers')}>
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" width="20" height="20">
                      <path d="M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2"/><circle cx="9" cy="7" r="4"/>
                      <path d="M23 21v-2a4 4 0 00-3-3.87M16 3.13a4 4 0 010 7.75"/>
                    </svg>
                  </button>
                )}
                <button onClick={() => startCall('audio', callMembers)} title={t('chat.voiceCall')}>
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" width="20" height="20">
                    <path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07A19.5 19.5 0 013.07 9.81a19.79 19.79 0 01-3.07-8.68 2 2 0 012-2.18h3a2 2 0 012 1.72c.127.96.361 1.903.7 2.81a2 2 0 01-.45 2.11L6.91 6.85a16 16 0 006.29 6.29l1.27-1.27a2 2 0 012.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0122 16.92z"/>
                  </svg>
                </button>
              </div>
            </div>

            {/* Group members panel */}
            {showMembers && activeConv?.type === 'group' && (
              <div className="modal-overlay" onClick={() => { setShowMembers(false); setShowAddMember(false); }}>
                <div className="modal" onClick={e => e.stopPropagation()} style={{maxWidth:480, width:'94%', maxHeight:'80vh', overflow:'auto'}}>
                  <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',padding:'18px 22px',borderBottom:'1px solid #f1f5f9'}}>
                    <div>
                      <h3 style={{margin:0,fontFamily:'var(--font-display)',fontSize:'1.1rem',fontWeight:800,color:'#0f172a'}}>{convName(activeConv)}</h3>
                      <div style={{fontSize:'0.8rem',color:'#64748b',marginTop:2}}>{groupMembers.length} {t('chat.member')}</div>
                    </div>
                    <button onClick={() => { setShowMembers(false); setShowAddMember(false); }}
                      style={{background:'#f1f5f9',border:'none',width:32,height:32,borderRadius:'50%',color:'#64748b',cursor:'pointer',padding:0,display:'flex',alignItems:'center',justifyContent:'center',flexShrink:0}}>
                      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round"><path d="M18 6L6 18M6 6l12 12"/></svg>
                    </button>
                  </div>

                  <div style={{padding:'14px 22px'}}>
                    {(isGroupAdmin || user.role === 'admin') && (
                      <button onClick={() => setShowAddMember(!showAddMember)}
                        style={{
                          width:'100%',padding:'10px 14px',marginBottom:14,
                          background:'linear-gradient(135deg,#007c82,#0891b2)',color:'#fff',border:'none',borderRadius:10,
                          fontWeight:700,fontSize:'0.88rem',cursor:'pointer',
                          display:'flex',alignItems:'center',justifyContent:'center',gap:6,
                          boxShadow:'0 2px 8px rgba(0,124,130,0.25)'
                        }}>
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2"><path d="M12 5v14M5 12h14"/></svg>
                        {t('chatGroup.addMember')}
                      </button>
                    )}

                    {showAddMember && (
                      <div style={{background:'#f8fafc',border:'1px solid #e2e8f0',borderRadius:12,padding:12,marginBottom:14}}>
                        <input type="text" placeholder={t('chat.searchUser')}
                          value={memberSearch} onChange={e => setMemberSearch(e.target.value)}
                          style={{width:'100%',padding:'8px 12px',border:'1.5px solid #e2e8f0',borderRadius:8,fontSize:'0.86rem',marginBottom:10,boxSizing:'border-box'}} />
                        <div style={{maxHeight:200,overflowY:'auto',display:'flex',flexDirection:'column',gap:4}}>
                          {allUsers
                            .filter(u => !groupMembers.find(m => m.id === u.id))
                            .filter(u => !memberSearch || (u.name||'').toLowerCase().includes(memberSearch.toLowerCase()))
                            // Əməkdaşlar əvvəl, şagirdlər sonra
                            .slice().sort((a, b) => (STAFF_ROLES.includes(a.role) ? 0 : 1) - (STAFF_ROLES.includes(b.role) ? 0 : 1))
                            .slice(0, 30).map(u => (
                            <label key={u.id} style={{display:'flex',alignItems:'center',gap:10,padding:'7px 10px',borderRadius:8,cursor:'pointer',background: memberToAdd.includes(u.id)?'#e0f2f4':'#fff',border:'1px solid '+(memberToAdd.includes(u.id)?'#007c82':'#e2e8f0')}}>
                              <input type="checkbox" checked={memberToAdd.includes(u.id)}
                                onChange={() => setMemberToAdd(p => p.includes(u.id) ? p.filter(x => x !== u.id) : [...p, u.id])} />
                              <div style={{width:30,height:30,borderRadius:'50%',background:'#e0f2f4',color:'#007c82',display:'flex',alignItems:'center',justifyContent:'center',fontWeight:700,fontSize:'0.8rem'}}>{(u.name||'?').charAt(0).toUpperCase()}</div>
                              <span style={{fontSize:'0.86rem',fontWeight:500,color:'#0f172a'}}>{u.name}</span>
                            </label>
                          ))}
                        </div>
                        {memberToAdd.length > 0 && (
                          <button onClick={submitAddMembers}
                            style={{width:'100%',marginTop:10,padding:'9px',background:'#059669',color:'#fff',border:'none',borderRadius:8,fontWeight:700,fontSize:'0.85rem',cursor:'pointer'}}>
                            {t('chatGroup.addSelected')} ({memberToAdd.length})
                          </button>
                        )}
                      </div>
                    )}

                    <div style={{display:'flex',flexDirection:'column',gap:6}}>
                      {groupMembers.map(m => (
                        <div key={m.id} style={{display:'flex',alignItems:'center',gap:10,padding:'9px 12px',borderRadius:10,background:'#fafbfc',border:'1px solid #f1f5f9'}}>
                          {m.avatar
                            ? <img src={m.avatar} alt="" style={{width:36,height:36,borderRadius:'50%',objectFit:'cover'}} />
                            : <div style={{width:36,height:36,borderRadius:'50%',background:'#e0f2f4',color:'#007c82',display:'flex',alignItems:'center',justifyContent:'center',fontWeight:700,fontSize:'0.92rem'}}>{(m.name||'?').charAt(0).toUpperCase()}</div>}
                          <div style={{flex:1,minWidth:0}}>
                            <div style={{fontSize:'0.9rem',fontWeight:600,color:'#0f172a'}}>{m.name} {m.id === user.id && <span style={{fontSize:'0.72rem',color:'#64748b'}}>({t('chatGroup.you')})</span>}</div>
                            <div style={{fontSize:'0.74rem',color:'#64748b'}}>{m.role === 'admin' ? <><Icon name="crown" size={12} /> {t('chatGroup.admin')}</> : t('chatGroup.member')}</div>
                          </div>
                          <div style={{display:'flex',gap:6,alignItems:'center'}}>
                            {(isGroupAdmin || user.role === 'admin') && m.id !== user.id && (
                              m.role === 'admin' ? (
                                <button onClick={() => changeRole(m.id, 'member')}
                                  title={t('chatGroup.demote')}
                                  style={{background:'#fef3c7',color:'#b45309',border:'none',padding:'5px 11px',borderRadius:8,fontSize:'0.76rem',fontWeight:700,cursor:'pointer'}}>↓ {t('chatGroup.demote')}</button>
                              ) : (
                                <button onClick={() => changeRole(m.id, 'admin')}
                                  title={t('chatGroup.promote')}
                                  style={{background:'#ede9fe',color:'#6d28d9',border:'none',padding:'5px 11px',borderRadius:8,fontSize:'0.76rem',fontWeight:700,cursor:'pointer'}}><Icon name="crown" size={12} /> {t('chatGroup.promote')}</button>
                              )
                            )}
                            {m.id === user.id ? (
                              <button onClick={() => removeMember(m.id)}
                                style={{background:'#fee2e2',color:'#b91c1c',border:'none',padding:'5px 11px',borderRadius:8,fontSize:'0.76rem',fontWeight:700,cursor:'pointer'}}>{t('chatGroup.leave')}</button>
                            ) : (isGroupAdmin || user.role === 'admin') && m.role !== 'admin' ? (
                              <button onClick={() => removeMember(m.id)}
                                style={{background:'#fee2e2',color:'#b91c1c',border:'none',padding:'5px 11px',borderRadius:8,fontSize:'0.76rem',fontWeight:700,cursor:'pointer'}}>{t('chatGroup.remove')}</button>
                            ) : null}
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            )}

            {/* Messages */}
            <div className="chat-messages">
              {hasMore && <button className="load-more-btn" onClick={loadMore}>Əvvəlki mesajlar</button>}
              {loadingMsgs && <div className="chat-loading">Yüklənir...</div>}
              {groupedMessages.map((item, i) => {
                if (item.type === 'date') return <div key={'d' + i} className="date-divider"><span>{item.label}</span></div>;
                const m = item.data;
                const isMine = m.sender_id === user.id;
                return (
                  <div key={m.id} className={'msg-wrap' + (isMine ? ' mine' : '')}>
                    {!isMine && activeConv.type === 'group' && (
                      <div className="msg-sender-name">{m.sender_name}</div>
                    )}
                    <div
                      className={'msg-bubble' + (m.is_deleted ? ' deleted' : '') + (isMine ? ' mine' : '') + (msgMenu === m.id ? ' menu-active' : '')}
                      onTouchStart={() => !m.is_deleted && startLongPress(m.id)}
                      onTouchEnd={cancelLongPress}
                      onTouchMove={cancelLongPress}
                      onTouchCancel={cancelLongPress}
                      onMouseDown={() => !m.is_deleted && startLongPress(m.id)}
                      onMouseUp={cancelLongPress}
                      onMouseLeave={cancelLongPress}
                      onContextMenu={(e) => { if (!m.is_deleted) { e.preventDefault(); setMsgMenu(m.id); } }}
                    >
                      {m.is_deleted ? (
                        <span className="deleted-text">Bu mesaj silindi</span>
                      ) : m.type === 'image' ? (
                        (() => {
                          const raw = m.file_url || '';
                          const isLocal = raw.startsWith('/uploads/') || raw.startsWith('/api/') || raw.includes('/uploads/chat/');
                          const url = isLocal
                            ? raw + (raw.includes('?') ? '&' : '?') + 'token=' + (localStorage.getItem('token') || '')
                            : raw;
                          const isGif = /\.gif(\?|$)/i.test(raw) || /\.gif$/i.test(m.file_name || '') || /giphy\.com|tenor\.com|media\.tenor/i.test(raw);
                          return (
                            <span className="msg-image-wrap">
                              <img
                                src={url}
                                alt={m.file_name}
                                className={'msg-image' + (isGif ? ' is-gif' : '')}
                                onClick={() => setLightbox({ url, name: m.file_name })}
                                loading="lazy"
                              />
                              {isGif && <span className="msg-gif-badge">GIF</span>}
                            </span>
                          );
                        })()
                      ) : m.type === 'file' ? (
                        <a href={m.file_url + (m.file_url?.includes('?') ? '&' : '?') + 'token=' + (localStorage.getItem('token') || '')} target="_blank" rel="noreferrer" className="msg-file">
                          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" width="16" height="16">
                            <path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z"/><polyline points="14,2 14,8 20,8"/>
                          </svg>
                          {m.file_name}
                        </a>
                      ) : (
                        <span>{m.content}</span>
                      )}
                      <div className="msg-meta">
                        <span className="msg-time">{formatTime(m.created_at)}</span>
                        {/* Oxunma nişanı — yalnız öz mesajlarımızda:
                            bir quş göndərilib, iki quş qarşı tərəf oxuyub */}
                        {isMine && !m.is_deleted && (
                          <span className={'msg-ticks' + (m.read_count > 0 ? ' read' : '')}
                                title={m.read_count > 0 ? t('chat.seen') : t('chat.sent')}>
                            <Icon name={m.read_count > 0 ? 'checkDouble' : 'check'} size={14} />
                          </span>
                        )}
                      </div>

                      {/* Reaksiya düyməsi — mesajın üstünə gələndə görünür */}
                      {!m.is_deleted && (
                        <button
                          type="button"
                          className={'msg-react-btn' + (isMine ? ' mine' : '')}
                          onClick={e => { e.stopPropagation(); openReactPicker(m.id, e.currentTarget); }}
                          title="Reaksiya bildir"
                        >
                          <Icon name="smile" size={15} />
                        </button>
                      )}

                      {reactFor === m.id && reactPos && createPortal(
                        <>
                          <div className="react-pick-overlay" onClick={() => setReactFor(null)} />
                          <div className="react-pick"
                               style={{ left: reactPos.left, top: reactPos.top, width: reactPos.width }}>
                            {REACTIONS.map(e => (
                              <button type="button" key={e} className="react-pick-btn"
                                      onClick={() => toggleReaction(m, e)}>{e}</button>
                            ))}
                          </div>
                        </>,
                        document.body
                      )}
                      {msgMenu === m.id && !m.is_deleted && (
                        <>
                          <div className="msg-menu-overlay" onClick={() => setMsgMenu(null)} />
                          <div className={'msg-menu' + (isMine ? ' mine' : '')}>
                            <button className="msg-menu-item" onClick={() => deleteForMe(m)}>
                              <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                <path d="M20 21v-2a4 4 0 00-4-4H8a4 4 0 00-4 4v2"/><circle cx="12" cy="7" r="4"/>
                              </svg>
                              Mənim üçün sil
                            </button>
                            {isMine && (
                              <button className="msg-menu-item danger" onClick={() => deleteForEveryone(m)}>
                                <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                  <polyline points="3,6 5,6 21,6"/><path d="M19 6l-2 14a2 2 0 01-2 2H9a2 2 0 01-2-2L5 6"/>
                                </svg>
                                Hamı üçün sil
                              </button>
                            )}
                          </div>
                        </>
                      )}
                    </div>

                    {/* Verilmiş reaksiyalar — mesajın altında */}
                    {!m.is_deleted && m.reactions && m.reactions.length > 0 && (
                      <div className={'msg-reactions' + (isMine ? ' mine' : '')}>
                        {m.reactions.map(r => (
                          <button
                            type="button"
                            key={r.emoji}
                            className={'react-chip' + (r.mine ? ' mine' : '')}
                            title={(r.names || []).join(', ')}
                            onClick={() => toggleReaction(m, r.emoji)}
                          >
                            <span className="react-chip-e">{r.emoji}</span>
                            {r.count > 1 && <span className="react-chip-n">{r.count}</span>}
                          </button>
                        ))}
                      </div>
                    )}
                  </div>
                );
              })}
              {Object.keys(typing).length > 0 && (
                <div className="typing-indicator">
                  <span>{Object.values(typing).join(', ')} yazır...</span>
                  <span className="typing-dots"><span></span><span></span><span></span></span>
                </div>
              )}
              <div ref={messagesEndRef} />
            </div>

            {/* Input */}
            <form className="chat-input-bar" onSubmit={sendMessage}>
              <button type="button" className="icon-btn" onClick={() => setShowEmoji(!showEmoji)}><Icon name="smile" size={18} /></button>
              {showEmoji && (
                <div className="picker-popover">
                  <div className="picker-tabs">
                    <button type="button" className={'picker-tab' + (pickerTab === 'emoji' ? ' active' : '')} onClick={() => setPickerTab('emoji')}><Icon name="smile" size={14} /> Emoji</button>
                    <button type="button" className={'picker-tab' + (pickerTab === 'gif' ? ' active' : '')} onClick={() => setPickerTab('gif')}>GIF</button>
                  </div>

                  {pickerTab === 'emoji' && (
                    <>
                      <input
                        type="text"
                        className="picker-search"
                        placeholder="Search emoji..."
                        value={emojiSearch}
                        onChange={e => setEmojiSearch(e.target.value)}
                      />
                      <div className="emoji-grid">
                        {EMOJIS
                          .filter(em => !emojiSearch.trim() || em.k.toLowerCase().includes(emojiSearch.trim().toLowerCase()))
                          .map(em => (
                            <button type="button" key={em.e} className="emoji-btn" onClick={() => insertEmoji(em.e)}>{em.e}</button>
                          ))}
                      </div>
                    </>
                  )}

                  {pickerTab === 'gif' && (
                    <>
                      <input
                        type="text"
                        className="picker-search"
                        placeholder="Search GIFs..."
                        value={gifSearch}
                        onChange={e => setGifSearch(e.target.value)}
                      />
                      <div className="gif-grid">
                        {gifLoading ? (
                          <div className="gif-loading">Loading...</div>
                        ) : gifResults.length === 0 ? (
                          <div className="gif-loading">No GIFs found</div>
                        ) : (
                          gifResults.map(g => (
                            <img
                              key={g.id}
                              src={g.preview}
                              alt="gif"
                              className="gif-thumb"
                              onClick={() => sendGif(g.full)}
                              loading="lazy"
                            />
                          ))
                        )}
                      </div>
                      <div className="picker-credit">Powered by Tenor</div>
                    </>
                  )}
                </div>
              )}
              {pendingImage && (
                <div className="paste-preview">
                  <img src={pendingImage.url} alt="" className="paste-preview-img" />
                  <div className="paste-preview-info">
                    <div className="paste-preview-title">Ekran görüntüsü yapışdırıldı</div>
                    <div className="paste-preview-sub">Göndərmək üçün Enter və ya "Göndər"</div>
                  </div>
                  <button type="button" className="paste-send" onClick={sendPendingImage} disabled={uploading}>
                    {uploading ? 'Göndərilir...' : 'Göndər'}
                  </button>
                  <button type="button" className="paste-cancel" onClick={clearPendingImage} aria-label="Ləğv et">
                    <Icon name="close" size={16} />
                  </button>
                </div>
              )}
              <button type="button" className="icon-btn" onClick={() => fileInputRef.current?.click()}>
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" width="18" height="18">
                  <path d="M21.44 11.05l-9.19 9.19a6 6 0 01-8.49-8.49l9.19-9.19a4 4 0 015.66 5.66l-9.2 9.19a2 2 0 01-2.83-2.83l8.49-8.48"/>
                </svg>
              </button>
              <input ref={fileInputRef} type="file" style={{ display:'none' }} onChange={handleFileUpload} accept="image/*,application/pdf,.doc,.docx,.xls,.xlsx,.txt" />
              <input
                className="chat-text-input"
                value={text}
                onChange={handleTextChange}
                placeholder="Mesaj yazın..."
                onPaste={handlePaste}
                onKeyDown={e => {
                  if (e.key === 'Enter' && !e.shiftKey) {
                    if (pendingImage) { e.preventDefault(); sendPendingImage(); return; }
                    sendMessage(e);
                  }
                  if (e.key === 'Escape' && pendingImage) clearPendingImage();
                }}
              />
              <button type="submit" className="send-btn" disabled={!text.trim()}>
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" width="18" height="18">
                  <line x1="22" y1="2" x2="11" y2="13"/><polygon points="22,2 15,22 11,13 2,9"/>
                </svg>
              </button>
            </form>
          </>
        )}
      </div>

      {/* New direct chat modal */}
      {showNewChat && (
        <div className="modal-overlay" onClick={() => setShowNewChat(false)}>
          <div className="chat-modal" onClick={e => e.stopPropagation()}>
            <div className="modal-header">
              <h3>Yeni söhbət</h3>
              <button onClick={() => setShowNewChat(false)}><Icon name="close" size={16} /></button>
            </div>
            <input className="modal-search" placeholder="İstifadəçi axtar..." value={searchUser} onChange={e => setSearchUser(e.target.value)} />
            <div className="user-tabs">
              <button type="button"
                className={'user-tab' + (userTab === 'staff' ? ' active' : '')}
                onClick={() => setUserTab('staff')}>
                Əməkdaşlar <span className="user-tab-n">{staffUsers.length}</span>
              </button>
              <button type="button"
                className={'user-tab' + (userTab === 'student' ? ' active' : '')}
                onClick={() => setUserTab('student')}>
                Şagirdlər <span className="user-tab-n">{studentUsers.length}</span>
              </button>
            </div>
            <div className="user-list">
              {filteredUsers.map(u => (
                <div key={u.id} className="user-list-item" onClick={() => startDirectChat(u.id)}>
                  <div className="conv-avatar sm">{u.name.charAt(0)}</div>
                  <div>
                    <div className="user-item-name">{u.name}</div>
                    <div className="user-item-role">{roleText(u.role)}</div>
                  </div>
                  {onlineUsers.has(u.id) && <span className="online-dot static"></span>}
                </div>
              ))}
            </div>
          </div>
        </div>
      )}

      {/* New group modal */}
      {showNewGroup && (
        <div className="modal-overlay" onClick={() => setShowNewGroup(false)}>
          <div className="chat-modal" onClick={e => e.stopPropagation()}>
            <div className="modal-header">
              <h3>Qrup yarat</h3>
              <button onClick={() => setShowNewGroup(false)}><Icon name="close" size={16} /></button>
            </div>
            <input className="modal-search" placeholder="Qrup adı..." value={groupName} onChange={e => setGroupName(e.target.value)} />
            <input className="modal-search" placeholder="Üzv axtar..." value={searchUser} onChange={e => setSearchUser(e.target.value)} style={{ marginTop: 8 }} />
            <div className="user-tabs">
              <button type="button"
                className={'user-tab' + (userTab === 'staff' ? ' active' : '')}
                onClick={() => setUserTab('staff')}>
                Əməkdaşlar <span className="user-tab-n">{staffUsers.length}</span>
              </button>
              <button type="button"
                className={'user-tab' + (userTab === 'student' ? ' active' : '')}
                onClick={() => setUserTab('student')}>
                Şagirdlər <span className="user-tab-n">{studentUsers.length}</span>
              </button>
            </div>
            <div className="user-list">
              {filteredUsers.map(u => (
                <div key={u.id} className={'user-list-item' + (selectedUsers.includes(u.id) ? ' selected' : '')}
                  onClick={() => setSelectedUsers(prev => prev.includes(u.id) ? prev.filter(x => x !== u.id) : [...prev, u.id])}>
                  <div className="conv-avatar sm">{u.name.charAt(0)}</div>
                  <div className="user-item-name">{u.name}</div>
                  {selectedUsers.includes(u.id) && <span className="check-mark">✓</span>}
                </div>
              ))}
            </div>
            <div className="modal-footer-btns">
              <span>{selectedUsers.length} üzv seçildi</span>
              <button className="btn-primary" onClick={createGroup} disabled={!groupName.trim() || selectedUsers.length === 0}>
                Qrup yarat
              </button>
            </div>
          </div>
        </div>
      )}

      {/* CALL UI */}
      {callState && (
        <div className="call-overlay">
          <div className="call-box">
            <div className="call-avatar">{callState === 'incoming' ? (callData?.from_name||'?').charAt(0) : convName(activeConv||{}).charAt(0)}</div>
            <div className="call-name">{callState === 'incoming' ? callData?.from_name : convName(activeConv||{})}</div>
            <div className="call-status">
              {callState === 'incoming' && 'Gələn zəng...'}
              {callState === 'calling' && 'Zəng edilir...'}
              {callState === 'active' && 'Zəng davam edir'}
            </div>
            <div className="call-actions">
              {callState === 'incoming' && (
                <>
                  <button className="call-btn accept" onClick={acceptCall}>
                    <svg viewBox="0 0 24 24" fill="currentColor" width="24" height="24"><path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07A19.5 19.5 0 013.07 9.81a19.79 19.79 0 01-3.07-8.68 2 2 0 012-2.18h3a2 2 0 012 1.72c.127.96.361 1.903.7 2.81a2 2 0 01-.45 2.11L6.91 6.85a16 16 0 006.29 6.29l1.27-1.27a2 2 0 012.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0122 16.92z"/></svg>
                  </button>
                  <button className="call-btn reject" onClick={rejectCall}>
                    <svg viewBox="0 0 24 24" fill="currentColor" width="24" height="24"><path d="M10.68 13.31a16 16 0 003.41 2.6l1.27-1.27a2 2 0 012.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0122 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07 19.5 19.5 0 01-5.33-5.33m-2-8.42a19.79 19.79 0 00-3.07-8.68 2 2 0 00-2-2.18H2a2 2 0 00-2 2.18A19.79 19.79 0 002.68 9.5M23 1L1 23"/></svg>
                  </button>
                </>
              )}
              {(callState === 'calling' || callState === 'active') && (
                <button className="call-btn reject" onClick={() => endCall(true)}>
                  <svg viewBox="0 0 24 24" fill="currentColor" width="24" height="24"><path d="M10.68 13.31a16 16 0 003.41 2.6l1.27-1.27a2 2 0 012.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0122 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07 19.5 19.5 0 01-5.33-5.33m-2-8.42a19.79 19.79 0 00-3.07-8.68 2 2 0 00-2-2.18H2a2 2 0 00-2 2.18A19.79 19.79 0 002.68 9.5M23 1L1 23"/></svg>
                </button>
              )}
            </div>
            <audio ref={localAudioRef} autoPlay muted />
          </div>
        </div>
      )}

      {lightbox && (
        <div className="msg-lightbox-overlay" onClick={() => setLightbox(null)}>
          <button className="msg-lightbox-close" onClick={(e) => { e.stopPropagation(); setLightbox(null); }}>
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
          </button>
          <img src={lightbox.url} alt={lightbox.name} className="msg-lightbox-img" onClick={(e) => e.stopPropagation()} />
        </div>
      )}
    </div>
  );
}
